import React from 'react';

const Button = ({ children, variant = "primary", className = "", onClick, ...props }) => {
  const baseClasses = "px-6 py-3 rounded-lg font-medium transition-all duration-200 cursor-pointer";
  const variants = {
    primary: "bg-black text-white hover:bg-gray-800",
    secondary: "bg-white text-black border border-black hover:bg-gray-50",
    gold: "bg-gradient-to-r from-yellow-400 to-yellow-600 text-black hover:from-yellow-500 hover:to-yellow-700"
  };
  
  return (
    <button 
      className={`${baseClasses} ${variants[variant]} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
